<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="error-template">
        <h1>
          Oops!
        </h1>
        <h2>
          Unauthorized
        </h2>
        <div class="error-details">
          Sorry, you are not authorized to view this page!
        </div>
        <div class="error-actions">
          <a [routerLink]="['/home']" class="btn btn-primary btn-lg">
            <span class="glyphicon glyphicon-home"></span>
            Take Me Home
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
